import enhancePostImages from "../components/viewLargePhoto";
import playVideoPeople from "../components/playVideoPeople";
import initGenericSliders from '../components/slider-generico';

export default function initPost() {

    const sliderElement = document.querySelectorAll('[data-swiper]');
    if (sliderElement) {
        initGenericSliders();
    }

    enhancePostImages();
    playVideoPeople();

}
